// components mui
import { Box, IconButton, Typography } from "@mui/material";

// icons
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// title row shared by every modal: optional back button, title and close button
const ModalHeader = ({ title, closeFunction, backArrow }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2.5, pt: 2.5, pb: 1 }}>
      {backArrow && typeof backArrow == "function" ? (
        <IconButton aria-label="back" edge="start" onClick={() => backArrow()}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      ) : null}
      <Typography variant="h6" component="h2" id="modal-modal-title" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      <IconButton aria-label="close" edge="end" onClick={closeFunction}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
